import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseService } from '../../shared/services/base.service';
import { HttpParams } from '@angular/common/http';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { StorageService } from '../../shared/services/storage.service';
import { includes } from 'lodash';
import { ModalSize } from '../../services/smart-modal.service';
@Component({
    selector: 'app-bookmarks',
    templateUrl: './bookmarks.component.html',
    styleUrls: ['./bookmarks.component.scss'],
    standalone: false
})

export class BookmarksComponent implements OnInit {

  @Input() bookmarks: any;
  @Input() expand: any;
  @Output() Entity = new EventEmitter<any>();
  @Output() Favourite = new EventEmitter<any>();
  bookmarksData: any = [];
  allBookmarks: any = [];
  searchConfig: boolean = true;
  radioFilter: boolean = false;
  expandButton: boolean = false;
  selectedEntity: any = {};
  @ViewChild('getElementHeight') cardElem: ElementRef;
  delete_fav: boolean = false;
  bookmark_config: any = {};
  selectedItems: any = [];

  constructor(private baseService: BaseService, private route?: ActivatedRoute,public alerts?: AlertsService,private storageService?:StorageService) { }

  ngOnInit() {
    this.bookmark_config.basedOn = 'doctor';
    if (this.bookmarks != undefined && this.bookmarks.bannerJson != undefined) {
      var bannerJson = this.bookmarks.bannerJson.datasource;
      this.getParamValueQueryString('key', (response)=>{
        if(response){
          var id = response;
          if (bannerJson.args == undefined)
            bannerJson['args'] = 'id:' + id;
          this.baseService.get(bannerJson.query_id, bannerJson.args, bannerJson.resource, bannerJson.application).subscribe(data => {
            if (data.resource != undefined && data.resource.length > 0)
              this.getBookMarks(data.resource[0]);
          })
        }
      });
    }
    else if (this.bookmarks != undefined && this.bookmarks.bookmark != undefined && this.bookmarks.bookmark.hasOwnProperty('cardData') && this.bookmarks.bookmark.cardData != undefined)
      this.getBookMarks(this.bookmarks.bookmark['cardData']);
    
    if(localStorage.currentUser){
      let c_user = JSON.parse(localStorage.currentUser);
      if(c_user.role_type && c_user.role_type.toLowerCase() == "practitioner"){
        this.delete_fav = true;
      }
      else if (this?.bookmarks?.bookmark?.proxy_type == 'medicationRequest' || this?.bookmarks?.bookmark?.proxy_type == 'clinicalOrder') {
        this.delete_fav = true;
      }
    }
  }
  deleteFavouriteAction(entity, i) {
    let value = entity.itemName?entity.itemName:(entity.text?entity.text:(entity.serviceItemName?entity.serviceItemName:(entity.fav_name?entity.fav_name:(entity.favourite_name?entity.favourite_name:(entity.illness?entity.illness:(entity.surgeryName?entity.surgeryName:''))))))
    this.baseService.action({id:(entity.favourite_id?entity.favourite_id:entity.id),name:value}, "deleteFavourite", "emr", "doctors_favourite").subscribe((res: any) => {
      if (res && res.errCode == 0) {
        this.bookmarksData.splice(i, 1);
        this.Favourite.emit(this.bookmarksData);
      }else{
        this.alerts.error(res.message);
      }
    })
  }
  
  deleteFavourite(entity, i) {
    var dialogRef = this.baseService.modalService.confirmCustomBtn("CONFIRM", "Are you sure you want to delete favourite ?", ModalSize.Sm);
    dialogRef.subscribe(result => {
      if (result) {
        this.deleteFavouriteAction(entity, i)
      }
    })
  }

  getParamValueQueryString( paramName, callback ) {
    if(this.route.snapshot.queryParams.key == undefined){
      const url = window.location.href;
      let paramValue;
      if (url.includes('?')) {
        const httpParams = new HttpParams({ fromString: url.split('?')[1] });
        paramValue = httpParams.get(paramName);
      }
      if(paramValue != null)
        callback(paramValue);
      else
        callback(false);
    }else{
      callback(this.route.snapshot.queryParams.key)
    }
  }

  addEntity(entity, i?) {
    if(Object.keys(this.selectedEntity)[0])
    {
      let j = Object.keys(this.selectedEntity)[0];
      if(j != i && this.bookmarksData && this.bookmarksData[j])
      {
        this.bookmarksData[j]['active'] = false;
        delete this.bookmarksData[j]['active'];
        delete this.selectedEntity[j];
      }
    }
    if(this.bookmarks.bookmark.type != "chiefcomplaint" && this.bookmarks.bookmark.type != "diagnosis" && this.bookmarks.bookmark.type != "surgery")
      delete entity.id;

    if(this.bookmarksData[i] != undefined && this.bookmarksData[i]['active']){
      delete this.bookmarksData[i]['active']
      if(this.selectedEntity[i] != undefined) { delete this.selectedEntity[i]}
    } else if(this.bookmarksData[i] != undefined){
      this.bookmarksData[i]['active'] = true
      if(this.bookmarks.bookmark != undefined && this.bookmarks.bookmark.config != undefined && this.bookmarks.bookmark.config.selectType != undefined && this.bookmarks.bookmark.config.selectType == "multi"){}
      else {  
        let removeFav = String(Object.values(this.selectedEntity)[0])
        if(removeFav != undefined && removeFav != "undefined" && this.bookmarksData[removeFav] && this.bookmarksData[removeFav].active != undefined)
          delete this.bookmarksData[removeFav].active
        this.selectedEntity = {}  
      }
      this.selectedEntity[i] = entity
    }
    //this.selectedEntity = entity;
    let addFav  = Object.values(this.selectedEntity)
    this.Entity.emit(addFav.length == 1 ? addFav[0] : addFav);
  }

  addMultipleEntity(entity){
    this.Entity.emit(entity);
  }

  getBookMarks(cardData, event?, flag = true) {
    if(event){
      this.bookmark_config.basedOn = event;
    }
    var resource = [];
    if (this.bookmarks.bookmark.datasource.filter != undefined && this.bookmarks.bookmark.datasource.filter.indexOf('getterKey') != -1) {
      this.bookmarks.bookmark.datasource.filter = this.bookmarks.bookmark.datasource.filter.replace('!!!getterKey!!!', cardData[this.bookmarks.bookmark.getterKey]);
    }
    if (this.bookmarks.bookmark.datasource.filter != undefined && this.bookmarks.bookmark.datasource.filter.indexOf('getterKeyExpression') != -1) {
      let item = cardData;
      let val = eval(this.bookmarks.bookmark.getterKeyExpression);
      this.bookmarks.bookmark.datasource.filter = this.bookmarks.bookmark.datasource.filter.replace('!!!getterKeyExpression!!!', val);
    }
    if (this.bookmarks.bookmark.datasource.args != undefined && this.bookmarks.bookmark.datasource.args.indexOf('!!!') != -1) {
      this.bookmarks.bookmark.datasource.args = this.baseService.buildDyanamicStr(this.bookmarks.bookmark.datasource.args, { data: cardData })
    }
    var bookmarkDatasource = JSON.parse(JSON.stringify(this.bookmarks.bookmark.datasource));
    if(event != undefined){
      if(bookmarkDatasource.filter != undefined){
        bookmarkDatasource.filter = bookmarkDatasource.filter + `,filter_based:${event}`
      } else{
        bookmarkDatasource['filter'] = `filter_based:${event}`
      }
    }
    this.baseService.get(bookmarkDatasource.query_id, bookmarkDatasource.args, bookmarkDatasource.resource, bookmarkDatasource.application, bookmarkDatasource.filter).subscribe(data => {
      if (data.resource) {
        data.resource.forEach(entity => {
          let items = entity.surgery || entity.packageData;
          if (this.bookmarks.bookmark.proxy_type == "pres_favourite" && items && items.length > 0 && !entity.text) {
            entity.text = items[0].text;
          }
          if (this.bookmarks.bookmark.proxy_type == "pres_favourite" && items && items.length > 1) {
            items.forEach(subItem => {
              resource.push({ ...entity, text: subItem.text, [entity.surgery ? 'surgery' : 'packageData']: [subItem] });
            });
          } else {
            if (entity[this.bookmarks.bookmark.proxy_type ? this.bookmarks.bookmark.proxy_type : this.bookmarks.bookmark.type]) {
              entity[this.bookmarks.bookmark.proxy_type ? this.bookmarks.bookmark.proxy_type : this.bookmarks.bookmark.type].forEach(en => {
                en.favourite_id = entity.id;
                en.bookmark_based_on = entity.bookmark_based_on;
              })
            }
            resource.push(this.bookmarks.bookmark.proxy_type == "pres_favourite" ? entity : (entity[this.bookmarks.bookmark.proxy_type ? this.bookmarks.bookmark.proxy_type : this.bookmarks.bookmark.type]));
          }
        })
        if(data.resource.length > 0){
          this.bookmarksData =[]
        } else if(data.resource.length == 0 && event != undefined) {
          this.alerts.error("No Favourite found for "+event)
          console.log("NO DATA FOUND")
        }
        resource.forEach(data => {
          if (data != undefined && Array.isArray(data) && data.length > 0) {
            data.forEach(element => {
              this.bookmarksData.push(element);
            });
          } else if(data != undefined && Object.keys(data).length > 0){
            this.bookmarksData.push(data);
          }
        })
        if(this.bookmarks.bookmark.datasource.key)
          this.bookmarksData.sort((a, b) => a[this.bookmarks.bookmark.datasource.key].localeCompare(b[this.bookmarks.bookmark.datasource.key]))

        if(this.bookmarksData.length > 0){
          this.allBookmarks = this.bookmarksData;
        }
        if(event == undefined || event == 'doctor' || (this.bookmarksData != undefined && this.bookmarksData.length > 0 && this.bookmarksData[0].doctor_id != undefined && this.bookmarksData[0].doctor_id != '')){
          this.Favourite.emit(this.bookmarksData); // to compare favourite list in form component
        }
        setTimeout(()=>{
          if(flag)
            this.updateExpandState();
        })
      }
    })
  }

  updateExpandState() {
    let doc = document.getElementById('bookmark-main-body-' + (this.bookmarks.bookmark.type ? this.bookmarks.bookmark.type : this.bookmarks.bookmark.resource));
    let expandData;
    this.storageService.getData('favoriteExpand', (data) => {
      expandData = data;
    });
    if (expandData && this.bookmarks.bookmark.resource && this.bookmarks.bookmark.resource == expandData.resource) {
      this.expandButton = true;
      let dt = document.getElementById('bookmark-main-container-v2-' + (this.bookmarks.bookmark.type ? this.bookmarks.bookmark.type : this.bookmarks.bookmark.resource));
      if (dt != null) {
        let cl = document.getElementById('bookmark-main-container-v2-' + (this.bookmarks.bookmark.type ? this.bookmarks.bookmark.type : this.bookmarks.bookmark.resource));
        if (expandData.expand) {
          this.expand = true;
          cl.classList.add('bm-expand');
          if (doc != null) {
            doc.classList.add('scroll-bookmark');
          }
        } else {
          this.expand = undefined;
          if (cl.classList.contains('bm-expand')) {
            cl.classList.remove('bm-expand');
            if (doc != null) {
              doc.classList.remove('scroll-bookmark');
            }
          }
        }
      }
    } else if (doc != null) {
      this.expandButton = doc.clientHeight < doc.scrollHeight;
      let dt = document.getElementById('bookmark-main-container-v2-' + (this.bookmarks.bookmark.type ? this.bookmarks.bookmark.type : this.bookmarks.bookmark.resource));
      if (dt != null) {
        let cl = document.getElementById('bookmark-main-container-v2-' + (this.bookmarks.bookmark.type ? this.bookmarks.bookmark.type : this.bookmarks.bookmark.resource));
        if (!this.expandButton || !expandData) {
          this.expand = undefined;
          if (cl.classList.contains('bm-expand')) {
            cl.classList.remove('bm-expand');
            if (doc != null) {
              doc.classList.remove('scroll-bookmark');
            }
          }
        } else {
          this.expand = true;
          cl.classList.add('bm-expand');
          if (doc != null) {
            doc.classList.add('scroll-bookmark');
          }
        }
      }
    }
  }

  getValue(val) {
    var shortname = val;
    if (val != undefined && val !="" && val.length > 48) {
      shortname = val.substring(0, 12) + " ...";
    }
    return shortname;
  }

  filterClick(event){
    if(event != undefined && this.allBookmarks != undefined && this.allBookmarks.length>0){
      let found = []
      this.allBookmarks.forEach(el => {
        if(el[this.bookmarks.bookmark.datasource.key].toLowerCase().indexOf(event.toLowerCase()) > -1){
          found.push(el)
        }
      })
      this.bookmarksData = found
    }
  }

  toggleFilter(event){
    this.radioFilter = !this.radioFilter
  }

  multiselect(entity, checked, i){
    let pos = -1;
    if(this.selectedItems.length > 0 )
       pos = this.selectedItems.findIndex(ind => ind.id === entity.id);

    if (checked) {
        if (pos === -1) {
            this.selectedItems.push(entity);
        }
    } else {
        if (pos > -1) {
            this.selectedItems.splice(pos, 1);
        }
    }
    console.log("Selected Items ", this.selectedItems);
  }

  toggleBtn(){
    // this.expand = undefined;
    if(this.expand == undefined){
      this.expand = true;
    }else{
      this.expand = undefined;
    }
    // let expand = false;
    // if(document.getElementById('bookmark-main-container-v2-'+(this.bookmarks.bookmark.type?this.bookmarks.bookmark.type:this.bookmarks.bookmark.resource))){
    //   let cl = document.getElementById('bookmark-main-container-v2-'+(this.bookmarks.bookmark.type?this.bookmarks.bookmark.type:this.bookmarks.bookmark.resource));
    //   expand = cl.classList.contains('bm-expand');
    // }
    this.storageService.setData('favoriteExpand', {'resource':this.bookmarks.bookmark.resource, 'expand':this.expand}, res => { })
    // console.log("I am clicked");
  }

}